export const servicesData = [
  {
    title: "E-commerce Platform Onboarding",
    description: "Seamless brand launch on premium platforms like Myntra, Nykaa, and Ajio with complete documentation support.",
    features: ["Complete documentation", "Brand compliance", "Product cataloging", "Vendor registration"]
  },
  {
    title: "Quick Commerce Integration",
    description: "Fast-track your brand on quick commerce platforms - Blinkit, BigBasket, and Swiggy Instamart for instant delivery.",
    features: ["Rapid onboarding", "Inventory setup", "Logistics coordination", "Real-time support"]
  },
  {
    title: "Account Management",
    description: "End-to-end account management ensuring optimal performance, sales growth, and platform compliance.",
    features: ["Performance tracking", "Campaign management", "Compliance monitoring", "Growth strategies"]
  }
];

export const allPlatformsData = {
  starter: {
    title: "Starter Platforms",
    platforms: ["Limeroad", "JioMart", "Swiggy Minis", "Amazon", "Flipkart", "Meesho", "Snapdeal"]
  },
  premium: {
    title: "Premium Platforms",
    platforms: ["Myntra", "Nykaa Fashion", "Nykaa Beauty", "Tata Cliq", "Ajio", "Ajio Gram", "Bewakoof", "Pepperfry", "Urban Ladder", "Jaypore", "The Loom", "Ensemble India", "FirstCry", "Hopscotch", "Little Muffet", "Mirraw", "Karmaplace", "Maccron", "Kindlife"]
  },
  luxe: {
    title: "Luxe Platforms",
    platforms: ["Myntra Luxe", "Tata Cliq Luxe", "Ajio Luxe", "Aza Fashions", "Pernia", "Ogaan", "Aashni & Co", "Elahe", "Agashe Store"]
  },
  international: {
    title: "International Platforms",
    platforms: ["Myntra Singapore", "Noon", "Distacart", "Walmart US", "Amazon US", "Alibaba", "eBay", "Muzai"]
  },
  quickCommerce: {
    title: "Quick Commerce",
    platforms: ["Myntra Now", "Blinkit", "Big Basket", "Swiggy Instamart", "Flipkart Minutes", "Amazon Fresh", "Slikk Club", "Pincode", "JioMart Express"]
  },
  privateLabeling: {
    title: "Private Labeling",
    platforms: ["Myntra Private Labeling", "Nykaa Private Labeling", "Ajio Private Labeling", "Aza Fashions Private Labeling", "Ogaan Private Labeling"]
  },
  pharmaWellness: {
    title: "Pharma & Wellness",
    platforms: ["Tata 1mg", "PharmEasy", "HealthMug", "HealthKart", "One Green", "Netmeds"]
  }
};

export const platformsData = [
  { name: "Myntra", category: "Fashion E-commerce" },
  { name: "Nykaa", category: "Beauty & Wellness" },
  { name: "Ajio", category: "Fashion E-commerce" },
  { name: "Zepto", category: "Quick Commerce" },
  { name: "Blinkit", category: "Quick Commerce" },
  { name: "Swiggy Instamart", category: "Quick Commerce" }
];

export const benefitsData = [
  { title: "Expert Platform Knowledge", desc: "Deep understanding of each platform's requirements and best practices" },
  { title: "Faster Time to Market", desc: "Streamlined onboarding process to get your brand live quickly" },
  { title: "Compliance Assured", desc: "100% compliance with platform guidelines and regulations" },
  { title: "Ongoing Support", desc: "Dedicated account management for sustained growth" },
  { title: "Multi-Platform Strategy", desc: "Strategic presence across fashion, beauty, and quick commerce" },
  { title: "Data-Driven Insights", desc: "Performance analytics and optimization recommendations" }
];

export const processData = [
  { step: "1", title: "Consultation", desc: "Understanding your brand and target platforms" },
  { step: "2", title: "Documentation", desc: "Preparing all necessary documents and assets" },
  { step: "3", title: "Onboarding", desc: "Seamless registration and platform integration" },
  { step: "4", title: "Launch & Support", desc: "Going live with continuous account management" }
];

export const faqsData = [
  {
    q: "What is e-commerce onboarding and why do I need it?",
    a: "E-commerce onboarding is the process of registering and setting up your brand on platforms like Myntra, Nykaa, or Ajio. We handle documentation, compliance, cataloging, and technical setup to ensure a smooth launch."
  },
  {
    q: "How long does the onboarding process take?",
    a: "Typically, the onboarding process takes 2-4 weeks depending on the platform and documentation readiness. Quick commerce platforms can be faster with 1-2 weeks turnaround."
  },
  {
    q: "Which platforms do you specialize in?",
    a: "We specialize in 70+ platforms including Myntra, Nykaa, Ajio, Amazon, Flipkart, Tata Cliq and quick commerce platforms like Zepto, Blinkit, and Swiggy Instamart. We also handle international marketplaces and private labeling."
  },
  {
    q: "Do you provide ongoing account management?",
    a: "Yes! We offer comprehensive account management services including performance monitoring, campaign optimization, compliance checks, and growth strategies."
  },
  {
    q: "What documents are required for onboarding?",
    a: "Typically you need GST registration, bank details, brand authorization, product catalogs, and trademark certificates. We'll guide you through the complete checklist."
  },
  {
    q: "Can you help with multiple platforms simultaneously?",
    a: "Absolutely! We can onboard your brand on multiple platforms simultaneously, creating a comprehensive omnichannel presence across 70+ marketplaces."
  }
];